module.exports = __webpack_public_path__ + "img/capac_cordoba.6cdb36e5.jpg";